
export { useGetRequirementStateByIdentifierQuery } from "./data-access"